export default "__VITE_ASSET__d5307ea3__"